<span #tagsFilterMenu style="cursor: pointer">Tags</span>
<fw-popover action="click" position="below-left" [trigger]="tagsFilterMenu" (isOpenChange)="isOpenChange($event)">
  <fw-layout-panel class="tag-select-menu" [rounded]="false" (click)="$event.stopPropagation()">
    <header><h4>Filter Tags</h4></header>
    <form class="form-full-width" [formGroup]="form">
      <div class="divider"></div>
      <fw-wrapped-input title="Contains">
        <fw-typeahead
          formControlName="contains"
          maxOptionsHeight="200px"
          [allowNew]="false"
          [options]="containsOptions()"
          (searchValueChange)="onContainsSearchChange($event)"
        />
      </fw-wrapped-input>
      <div class="divider"></div>
      <fw-wrapped-input title="Doesn't Contain">
        <fw-typeahead
          formControlName="excludes"
          maxOptionsHeight="200px"
          [allowNew]="false"
          [options]="excludesOptions()"
          (searchValueChange)="onExcludesSearchChange($event)"
        />
      </fw-wrapped-input>
      <div class="divider"></div>
      <fw-button test-id="reset-filters-button" variant="outline" (click)="reset()">Reset Filters</fw-button>
    </form>
  </fw-layout-panel>
</fw-popover>
